import { Component, OnInit, ChangeDetectionStrategy, HostBinding, Input, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { AnimationStateEnum } from 'src/app/animations/animation-state.enum';
import { Animations } from 'src/app/animations/animations';
import { NgIf } from "@angular/common";

@Component({
    selector: 'mine-expansion-panel',
    templateUrl: './mine-expansion-panel.component.html',
    styleUrls: ['./mine-expansion-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [Animations.showHide()],
    imports: [NgIf]
})
export class MineExpansionPanelComponent implements OnInit {

	@Input()
	label: string;

	@Input()
	id: string = "input";

	private _isOpen: boolean = false;

	@Input()
	get isOpen(): boolean { return this._isOpen; }
	set isOpen(value: boolean) {
		this._isOpen = !!value;
		this.state = this._isOpen ? AnimationStateEnum.Show : AnimationStateEnum.Hide;
	}
	
	@Input() disableToggle: boolean = false;

    @Input() disableContent: boolean = false;

	@Output() stateChanged = new EventEmitter<boolean>();

	state: AnimationStateEnum.Hide | AnimationStateEnum.Show;

	AnimationStateEnum = AnimationStateEnum;

	@ViewChild('panelContent', { static: true }) panelContent: ElementRef;
  
	@HostBinding('class.expanded')
	get expanded() {
		return this.state === AnimationStateEnum.Show;
	}

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit(): void {
		this.state = this.isOpen ? AnimationStateEnum.Show : AnimationStateEnum.Hide;
	}

	toggle() {
		if (!this.disableToggle) {
			this.state = this.state === AnimationStateEnum.Hide ? AnimationStateEnum.Show : AnimationStateEnum.Hide;
			this._isOpen = this.state === AnimationStateEnum.Show;
			this.stateChanged.emit(this._isOpen);
		}
	}

	// use it when u need to close the panel manualy from outside
	forceClose() {
		if (!this.panelContent) return;
		this.state = AnimationStateEnum.Hide;
		this._isOpen = false;
		this.stateChanged.emit(this._isOpen);
		this.cdr.detectChanges();
	}

	forceOpen(): void {
		this.state = AnimationStateEnum.Show;
		this._isOpen = true;
		this.stateChanged.emit(this._isOpen);
		this.cdr.detectChanges();
	}

	onAnimationStart(): void {
		if (this.panelContent) {
			this.panelContent.nativeElement.style.overflow = 'hidden';
		}
	}

	onAnimationDone(): void {
		if (this.panelContent && this.state === AnimationStateEnum.Show) {
			this.panelContent.nativeElement.style.overflow = 'unset';
		}
	}
}
